import React from 'react';
import {createRoot} from 'react-dom/client';
import IndexView from './app/IndexView';
import './index.css';
import 'core-js/proposals/relative-indexing-method';

// import 'react-inner-image-zoom/lib/styles.min.css';

createRoot(document.getElementById('root')!).render(<IndexView />);

module.hot?.accept();
